angular.module('bmsApp.global')
	.controller('ManualRouteModalCtrl', [
		'$scope',
		'ConfigService',
		'DistanceConverterSvc',
		'uiGmapGoogleMapApi',
		'uiGmapIsReady',
		'$q',
		'$timeout',
		'notify',
		'$ngBootbox',
		'$modalInstance',
		'manualRoute',
		function ($scope,
				  ConfigService,
				  DistanceConverterSvc,
				  uiGmapGoogleMapApi,
				  uiGmapIsReady,
				  $q,
				  $timeout,
				  notify,
				  $ngBootbox,
				  $modalInstance,
				  manualRoute) {

			function init() {
				self.loading = true;
				self.date = manualRoute.date;
				self.config = angular.copy(ConfigService.config);
				// show map once parent element is rendered
				$q.all([
					$modalInstance.rendered,
					uiGmapGoogleMapApi
				])
					.then(function () {
						// timeout ensures map isn't displayed until parent container is rendered
						$timeout(function () {
							$scope.$apply(function () {
								self.loading = false;
							});
						});
						_getDirections();
					});
				self.uiTimepickerOptions = angular.copy(ConfigService.config.uiTimepickerOptions);
				self.uiTimepickerOptions.appendTo = '.manual-route-modal';

				let departureDateWatch = $scope.$watch(() => {
					return self.manualRoute.departureTime;
				}, (newVal, oldVal, scope) => {
					if (newVal !== oldVal) {
						onDepartureTimeChanged();
					}
				});


				if ($scope.isTG()) {
					if (angular.isObject(manualRoute.employee) && angular.isObject(manualRoute.employee.tg_route)) {
						if (!manualRoute.employee.tg_route.auto_optimised) {
							optimiseRoute();
							self.auto_optimised = true;
						}
					}
				}

				if ($scope.isMM()) {

				}
			}

			function onWaypointOrderChanged() {
				_getDirections();
			}

			function onDepartureTimeChanged() {
				_getDirections();
			}

			function confirm() {
				$modalInstance.close({
					manualRoute: self.manualRoute,
					summary: self.routeOverview.summary,
				});
			}

			function optimiseRoute() {
				if (self.manualRoute.waypoints.length > 23) {
					$ngBootbox.alert('Only routes with 23 or less waypoints may be optimised.');
				} else {
					_getDirections(true);
				}
			}

			function cancel() {
				$ngBootbox.confirm('Are you sure you want to close, any changes to the route order will be lost?')
					.then(function () {
						$modalInstance.dismiss('cancel');
					});
			}

			function _processWaypoints() {
				var deferred = $q.defer();
				var ok = true;
				let missingGeocodePostcodes = [];

				self.manualRoute.waypointMarkers = [];
				for (var i = 0; i < self.manualRoute.waypoints.length; i++) {
					var waypoint = self.manualRoute.waypoints[i];
					var index = i;
					if (angular.isNumber(waypoint.latitude) && angular.isNumber(waypoint.longitude)) {
						waypoint.valid = true;
						let markerI = index + 1;
						if (markerI > 24) {
							markerI = 'x';
						}
						waypoint.icon = 'images/markers/marker-icon-' + markerI + '.png';
						self.manualRoute.waypointMarkers.push(angular.copy(waypoint));
					}
					else {
						ok = false;
						waypoint.valid = false;
						missingGeocodePostcodes.push(waypoint.postcode);
					}
				}

				if (ok) {
					deferred.resolve();
				}
				else {
					self.errors.push('One or more waypoints requires geocoding. (' + missingGeocodePostcodes.join(',') + ')');
					deferred.reject({
						missingGeocodePostcodes: missingGeocodePostcodes,
					});
				}

				return deferred.promise;
			}

			var endpointsProcessed = false;

			function _processEndpoints() {
				var deferred = $q.defer();

				if (endpointsProcessed) {
					deferred.resolve();
				}
				else {
					var geocodePromises = {};
					geocodePromises.origin = _geocodeLocation(self.manualRoute.origin)
						.then(function (latLng) {
							if (self.manualRoute.destination == self.manualRoute.origin) {
								self.manualRoute.destination = latLng;
							}
							self.manualRoute.origin = latLng;
							self.manualRoute.originMarker = {
								id: 'origin',
								latitude: latLng.lat(),
								longitude: latLng.lng(),
								options: {
									icon: 'images/markers/marker-icon-checkered-flag.png'
								}
							};
						}, function () {
							self.errors.push('The start location could not be geocoded.');
							deferred.reject();
							console.info(self.manualRoute.origin);
						});
					if (self.manualRoute.destination != self.manualRoute.origin) {
						geocodePromises.destination = _geocodeLocation(self.manualRoute.destination)
							.then(function (latLng) {
								self.manualRoute.destination = latLng;
								self.manualRoute.destinationMarker = {
									id: 'destination',
									latitude: latLng.lat(),
									longitude: latLng.lng(),
									options: {
										icon: 'images/markers/marker-icon-checkered-flag.png'
									}
								};
							}, function () {
								self.errors.push('The finish location could not be geocoded.');
								deferred.reject();
								console.info(self.manualRoute.destination);
							});
					}
					$q.all(geocodePromises)
						.then(function () {
							endpointsProcessed = true;
							deferred.resolve();
						});
				}

				return deferred.promise;
			}

			function _geocodeLocation(location) {
				var deferred = $q.defer();

				uiGmapGoogleMapApi.then(function (maps) {
					if (location instanceof maps.LatLng) {
						deferred.resolve(location);
					}
					else if (angular.isObject(location)) {
						if (angular.isNumber(location.latitude) && angular.isNumber(location.longitude)) {
							deferred.resolve(new maps.LatLng(parseFloat(location.latitude), parseFloat(location.longitude)));
						}
						else if (angular.isNumber(location.lat) && angular.isNumber(location.lng)) {
							deferred.resolve(new maps.LatLng(parseFloat(location.lat), parseFloat(location.lng)));
						}
						else {
							deferred.reject();
						}
					}
					else {
						var geocoder = new maps.Geocoder();
						geocoder.geocode({
							address: location,
							region: 'GB'
						}, function (results, status) {
							if (status == 'OK') {
								deferred.resolve(results[0].geometry.location);
							}
							else {
								deferred.reject();
							}
						});
					}
				});

				return deferred.promise;
			}

			function _getDirections(optimise) {
				let deferred = $q.defer();
				let optimizeWaypoints = !!optimise;

				// clear all errors
				self.errors.length = 0;

				// clear the outbound and return paths
				self.routeOverview.outbound.path = undefined;
				self.routeOverview.return.travelDurationSeconds = 0;
				self.routeOverview.return.travelDistanceMetres = 0;
				self.routeOverview.return.travelDistanceMiles = 0;
				self.routeOverview.return.arrivalTime = null;
				self.routeOverview.return.path = undefined;
				self.routeOverviewLoading = true;

				$q.all({
					processWaypoints: _processWaypoints(),
					processEndpoints: _processEndpoints(),
					mapsApi: uiGmapGoogleMapApi
				})
					.then(function (responses) {
						let mapsApi = responses.mapsApi;
						let bounds = new mapsApi.LatLngBounds();
						// Fit map to bounds
						bounds.extend(self.manualRoute.origin);
						bounds.extend(self.manualRoute.destination);
						for (let i = 0; i < self.manualRoute.waypoints.length; i++) {
							let waypoint = self.manualRoute.waypoints[i];
							waypoint.latLng = new mapsApi.LatLng(parseFloat(waypoint.latitude), parseFloat(waypoint.longitude));
							bounds.extend(waypoint.latLng);
						}
						$timeout(function () {
							self.map.control.getGMap().fitBounds(bounds);
						});
						// Split directions api calls to allow for 'unlimited' waypoints
						let maxWaypointsPerCall = 25;
						let directionsSplitCount = Math.ceil((self.manualRoute.waypoints.length + 2) / maxWaypointsPerCall); // +2 for the origin and destination
						let waypointChunks = _.chunk(self.manualRoute.waypoints, directionsSplitCount === 1 ? 23 : 23);
						let directionRequests = {};
						for (let i = 0; i < directionsSplitCount; i++) {
							let origin;
							let destination;
							if (i === 0) {
								origin = self.manualRoute.origin;
							} else {
								origin = waypointChunks[i-1][22].latLng;
							}
							if ((i + 1) === directionsSplitCount) {
								destination = self.manualRoute.destination;
							} else {
								destination = waypointChunks[i][waypointChunks[i].length-1].latLng;
							}
							let request = {
								origin: origin,
								destination: destination,
								waypoints: [],
								travelMode: mapsApi.TravelMode['DRIVING'],
								optimizeWaypoints: optimizeWaypoints,
								region: 'GB'
							};
							if (waypointChunks[i] !== undefined) {
								for (let ii = 0; ii < waypointChunks[i].length; ii++) {
									request.waypoints.push({
										location: waypointChunks[i][ii].latLng,
									});
								}
							}
							directionRequests['direction_call_' + i] = request;
						}

 						// Make directions request
						let directionCalls = {};

						angular.forEach(directionRequests, (request, key) => {
							directionCalls[key] = _directionsCall(request);
						});

						$q.all(directionCalls).then((responses) => {
							self.routeOverview.summary.travelDurationSeconds = 0;
							self.routeOverview.summary.travelDistanceMetres = 0;
							self.routeOverview.summary.travelDistanceMiles = 0;
							self.routeOverview.summary.jobDurationSeconds = 0;

							self.routeOverview.outbound.path = [];
							self.routeOverview.return.travelDurationSeconds = 0;
							self.routeOverview.return.travelDistanceMetres = 0;
							self.routeOverview.return.travelDistanceMiles = 0;
							self.routeOverview.return.arrivalTime = null;
							self.routeOverview.return.path = [];

							// Manually iterate as response comes through in different orders
							let i = 0;
							let routeTime = moment.isMoment(self.manualRoute.departureTime) ? self.manualRoute.departureTime.clone() : new moment(self.manualRoute.departureTime, 'HH:mm:ss');

							angular.forEach(directionRequests, (request, key) => {
								if (optimizeWaypoints) {
									// Re-order waypoints BEFORE calculating arrival/departure times otherwise they will be wrong
									let originalWaypoints = angular.copy(self.manualRoute.waypoints);
									self.manualRoute.waypoints.length = 0;
									angular.forEach(responses[key].routes[0].waypoint_order, (waypointKey) => {
										self.manualRoute.waypoints.push(originalWaypoints[waypointKey]);
									});
									_processWaypoints();
								}

								angular.forEach(responses[key].routes[0].legs, (leg, legKey) => {
									// Add totals
									self.routeOverview.summary.travelDurationSeconds += leg.duration.value;
									self.routeOverview.summary.travelDistanceMetres += leg.distance.value;
									self.routeOverview.summary.travelDistanceMiles += DistanceConverterSvc.convertFromMetres(leg.distance.value, 'mi');
									// Add paths
									for (let ii = 0; ii < leg.steps.length; ii++) {
										let step = leg.steps[ii];
										self.routeOverview.outbound.path = self.routeOverview.outbound.path.concat(step.path);
									}
									// Add data to waypoint
									let waypoint = self.manualRoute.waypoints[i];
									if (waypoint) {
										routeTime.add(leg.duration.value, 's');
										waypoint.arrivalTime = routeTime.clone();
										waypoint.travelDurationSeconds = leg.duration.value;
										waypoint.travelDistanceMetres = leg.distance.value;
										waypoint.travelDistanceMiles = DistanceConverterSvc.convertFromMetres(leg.distance.value, 'mi');
										routeTime.add(waypoint.jobDurationSeconds, 's');
										waypoint.departureTime = routeTime.clone();
										self.routeOverview.summary.jobDurationSeconds += parseInt(waypoint.jobDurationSeconds);
									}
									else {
										// return journey
										self.routeOverview.return.travelDurationSeconds = leg.duration.value;
										self.routeOverview.return.travelDistanceMetres = leg.distance.value;
										self.routeOverview.return.travelDistanceMiles = DistanceConverterSvc.convertFromMetres(leg.distance.value, 'mi');
										self.routeOverview.return.arrivalTime = routeTime.clone();
										self.routeOverview.return.arrivalTime.add(self.routeOverview.return.travelDurationSeconds, 's');
									}
									i++;
								});
							});
							self.routeOverviewLoading = false;
							deferred.resolve();
						}, (errors) => {
							self.routeOverviewLoading = false;
							self.errors.push('Failed to load route data.');
							deferred.reject();
						});
					}, function (errors) {
						self.routeOverviewLoading = false;
					});

				return deferred.promise;
			}

			function _directionsCall(callRequest) {

				let deferred = $q.defer();
				uiGmapGoogleMapApi.then((maps) => {
					let directionsService = new maps.DirectionsService();
					directionsService.route(callRequest, function (response, status) {
						if (status === 'OK' && response.routes.length > 0) {
							deferred.resolve(response);
						}
						else {
							deferred.reject(status);
						}
					});
				});
				return deferred.promise;
			}

			function markerClick(instance, event, marker) {
				self.selectedMarker = marker;
			}

			var self = $scope.ManualRouteModalCtrl = {
				errors: [],
				manualRoute: manualRoute,
				routeOverview: {
					outbound: {
						path: undefined,
						stroke: {
							color: '#4285F4',
							weight: 4,
							opacity: 0.8
						}
					},
					'return': {
						path: undefined,
						stroke: {
							color: '#ae7e01',
							weight: 3,
							opacity: 0.8
						}
					},
					summary: {
						travelDurationSeconds: undefined,
						travelDistanceMetres: undefined,
						travelDistanceMiles: undefined,
						jobDurationSeconds: undefined
					}
				},
				routeOverviewLoading: false,
				map: {
					center: {
						latitude: 54.799188455250395,
						longitude: -2.6699218749999964,
					},
					zoom: 6,
					control: {}
				},
				methods: {
					init: init,
					onWaypointOrderChanged: onWaypointOrderChanged,
					onDepartureTimeChanged: onDepartureTimeChanged,
					confirm: confirm,
					optimiseRoute: optimiseRoute,
					cancel: cancel,
					markerClick: markerClick
				}
			};

		}
	]);
